import fr from 'facet-rest';
import { navigateLinkToClientPage } from 'Helpers/Navigation';

export const navigateToFunding = (resource, openInNewTab = false) => {
  let link;
  // funding instruction page takes precedence over transfer wizard
  if (resource.relationship(fr.relationships.fundingInstructionsPage.name)) {
    link = resource.relationship(fr.relationships.fundingInstructionsPage.name).link('related');
  } else {
    link = resource.relationship(fr.relationships.transferWizard.name).link('related');
  }

  navigateLinkToClientPage(link, openInNewTab);
};
